import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchAffiliateInvoice,
  initializeAffiliateInvoiceScreen,
  saveAffiliateInvoiceTableState,
  generateAffiliateInvoice,
  downloadAffiliateInvoice,
  updateAffiliateInvoice,
} from "../../../redux/actions/Affiliate/affiliateInvoice";
import { exportAffiliate, fetchAffiliateDD } from "../../../redux/actions/Affiliate/affiliate";
import AffiliateInvoice from "../../../component/Affiliate/AffiliateInvoice";
import { loadingShow } from "../../../services/PostAPI";
import { FILTER } from "../../../services/common/urlService";
import { APP_URLS } from "../../../utils/constant";
import { ProgressBar } from "primereact/progressbar";

function AffiliateInvoiceScreen(props) {
  const {
    fetchAffiliateInvoice,
    initAffiliateInvoiceScreen,
    showPageLevelLoader,
    affiliateInvoiceListview,
    paginationInfo,
    screenPermissions,
    isLoading,
    savedTableState,
    saveAffiliateInvoiceTableState,
    exportAffiliate,
  } = props;

  const navigate = useNavigate();
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;

    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach((key) => {
        if (
          key !== "global" &&
          state.filters[key]?.value !== null &&
          state.filters[key]?.value !== undefined
        ) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: filterValue,
          });
        }
      });
    }

    return {
      sortField: state.sortField || "id",
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId"),
    };
  };

  useEffect(() => {
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    // Fetch affiliate dropdown
    props.fetchAffiliateDD();
    
    if (savedParams) {
      fetchAffiliateInvoice(savedParams);
    } else {
      // Initialize and fetch with default params
      initAffiliateInvoiceScreen();
      fetchAffiliateInvoice({
        sortField: "id",
        sortOrder: -1,
        pageNumber: 0,
        pageSize: 10,
        userId: localStorage.getItem("userId"),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchAffiliateInvoice(props);
  };

  const handleViewInvoice = (rowData) => {
    navigate(APP_URLS.AFFILIATE_INVOICE.VIEW.replace(":invoiceId", rowData));
  };

  const handleTableStateChange = (tableState) => {
    saveAffiliateInvoiceTableState(tableState);
  };

  const handleUpdateInvoice = (invoiceId, status) => {
    const currentParams = buildFetchParamsFromSavedState(savedTableState);
    props.updateAffiliateInvoice(invoiceId, status, currentParams);
  };

  const affiliateInvoiceProps = {
    isLoading,
    screenPermissions,
    handleViewInvoice,
    fetchAffiliateInvoices: loadLazyData,
    tableData: {
      columns: affiliateInvoiceListview?.columns,
      rows: affiliateInvoiceListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    savedTableState,
    onTableStateChange: handleTableStateChange,
    exportAffiliateInvoice: exportAffiliate,
    generateAffiliateInvoice: props.generateAffiliateInvoice,
    downloadAffiliateInvoice: props.downloadAffiliateInvoice,
    updateAffiliateInvoice: handleUpdateInvoice,
    isGenerateInvoiceSuccess: props.isGenerateInvoiceSuccess,
    isGenerateInvoiceError: props.isGenerateInvoiceError,
    isUpdateInvoiceSuccess: props.isUpdateInvoiceSuccess,
    isUpdateInvoiceError: props.isUpdateInvoiceError,
    affiliateDD: props.affiliateDD,
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");

  return (
    <div>
      {isLoading && renderProgressBar()}
      <AffiliateInvoice {...affiliateInvoiceProps} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initAffiliateInvoiceScreen: () => dispatch(initializeAffiliateInvoiceScreen()),
    fetchAffiliateInvoice: (payload) => dispatch(fetchAffiliateInvoice(payload)),
    saveAffiliateInvoiceTableState: (payload) =>
      dispatch(saveAffiliateInvoiceTableState(payload)),
    exportAffiliate: () => dispatch(exportAffiliate()),
    generateAffiliateInvoice: (payload) => dispatch(generateAffiliateInvoice(payload)),
    downloadAffiliateInvoice: (invoiceId) => dispatch(downloadAffiliateInvoice(invoiceId)),
    updateAffiliateInvoice: (invoiceId, status, currentParams) =>
      dispatch(updateAffiliateInvoice(invoiceId, status, currentParams)),
    fetchAffiliateDD: () => dispatch(fetchAffiliateDD()),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    affiliateInvoiceListview: selectAffiliateInvoiceList(state.affiliateInvoiceReducer),
    showPageLevelLoader: selectIsLoadingPage(state.affiliateInvoiceReducer),
    paginationInfo: selectPaginationInfo(state.affiliateInvoiceReducer),
    isPageLevelError: selectIsPageLevelError(state.affiliateInvoiceReducer),
    isLoading: selectIsLoading(state.affiliateInvoiceReducer),
    savedTableState: state.affiliateInvoiceReducer?.savedTableState,
    isGenerateInvoiceSuccess: state.affiliateInvoiceReducer?.isGenerateInvoiceSuccess,
    isGenerateInvoiceError: state.affiliateInvoiceReducer?.isGenerateInvoiceError,
    isUpdateInvoiceSuccess: state.affiliateInvoiceReducer?.isUpdateInvoiceSuccess,
    isUpdateInvoiceError: state.affiliateInvoiceReducer?.isUpdateInvoiceError,
    affiliateDD: state.affiliateReducer?.affiliateDD || {},
  };
};

const selectIsLoading = (reducer) => reducer?.isLoading;
const selectPaginationInfo = (reducer) => reducer?.paginationInfo;
const selectIsLoadingPage = (reducer) => reducer?.isLoadingPage;
const selectIsPageLevelError = (reducer) => reducer?.isPageLevelError;
const selectAffiliateInvoiceList = (reducer) => reducer?.affiliateInvoiceListview;

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateInvoiceScreen);
